module.exports = {"globalPath":"https://www.going-link.com/","frontPath":"//www.going-link.com"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/js/global.json
// module id = 228
// module chunks = 12